import React from "react"
import PropTypes from "prop-types"
import { useOutletContext } from "react-router-dom"

import CreateModal from "@components/Page/CreateModal"
import { getFormSchema, TYPE_AMOUNT } from "@components/Form"

const LABEL_ADD = "Connect"
const LABEL_TITLE = "Connect Property"
const LABEL_ENTITY = "Property"
const LABEL_SUCCESS_MESSAGE = "Property is connected to the fund"

const createOperation = "backstage/ConnectFundProjectProperty"
const indexPropertiesOperation = "backstage/IndexProperties"

const getCreateSchema = getFormSchema(createOperation)
const createSchema = getCreateSchema([
  {
    name: "propertyId",
    label: "Property",
    options: indexPropertiesOperation,
    placeholder: "Select property to add",
  },
  {
    name: "status",
    inputProps: { style: { width: 220 } },
    placeholder: "Set status of the property",
    initialValue: "ACTIVE",
  },
  {
    name: "investmentDate",
  },
  {
    name: "equityDeployedAmount",
    type: TYPE_AMOUNT,
    label: "Equity Deployed",
    inputProps: { style: { width: 130 }, controls: false },
    placeholder: ""
  },
])


const ConnectFundProjectPropertyModal = ({ modal }) => {
  const { project, readProject } = useOutletContext()

  const onSuccess = () =>
    readProject(project.id)

  const onSubmit = parameters =>
    ({ ...parameters, id: project.id })

  return (
    <CreateModal
      modal={modal}
      title={LABEL_TITLE}
      entity={LABEL_ENTITY}
      schema={createSchema}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      operation={createOperation}
      submitLabel={LABEL_ADD}
      successMessage={LABEL_SUCCESS_MESSAGE}
    />
  )
}

ConnectFundProjectPropertyModal.propTypes = {
  modal: PropTypes.shape({}).isRequired,
}

export default ConnectFundProjectPropertyModal
